import React from 'react';

import { Divider, Skeleton, type SkeletonProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import { StyledLoadingFieldsetAdvanced } from '../../../../ClassModal/Sections/index.styles';

const CustomSkeleton = (props: SkeletonProps) => <Skeleton {...props} animation="wave" />;

const StyledLoadingFieldsetAdvanced2 = styled(StyledLoadingFieldsetAdvanced)`
    margin: 0;
    padding: 0.75rem 0;
    border-bottom: none;
    max-width: 600px;
`;

export const ClassDetailLoadingForm = () => (
    <form>
        <CustomSkeleton width={550} height={60} />
        <CustomSkeleton width={550} height={60} />
        <CustomSkeleton width={550} height={60} />
        <CustomSkeleton width={550} height={60} />
        <CustomSkeleton width={550} height={60} />

        <Divider sx={{ my: 2 }} />

        <StyledLoadingFieldsetAdvanced2>
            {[...Array(7).keys()].map((_, index) => (
                <CustomSkeleton sx={{ margin: 0, width: '100%' }} key={index} height={60} />
            ))}
        </StyledLoadingFieldsetAdvanced2>

        <CustomSkeleton width={200} height={60} />

        <Divider sx={{ my: 2 }} />

        <CustomSkeleton width={100} height={60} />
    </form>
);
